export const PARENT_USER_TYPE = 'parent';
export const PROVIDER_USER_TYPE = 'provider';
